import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'

export class TablaStock extends Component {
  state = {}

  static propTypes = {
    datosStock: PropTypes.array.isRequired,
  }

  render() {
    return (
      <Fragment>
        <form className='form-inline form-default stock'>
          <h4> Stock </h4>
          <table className='table'>
            <thead>
              <tr className='table-title'>
                <th scope='col'>Bodega</th>
                <th scope='col'>Cantidad</th>
                <th scope='col'>Presentacion</th>
              </tr>
            </thead>
            <tbody>
              {this.props.datosStock.map((regStock, index) => {
                return (
                  <tr key={index}>
                    <td className='col'>{regStock.codigo_almacen}</td>
                    <td className='col'>{regStock.cantidad_presentacion}</td>
                    <td className='col'>{regStock.presentacion}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </form>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({})

export default connect(mapStateToProps)(TablaStock)
